import { useDisclosure } from '@chakra-ui/react';

interface UseContactModalProps {
  defaultMessage?: string;
  defaultInterest?: string;
  title?: string;
  submitButtonText?: string;
}

export const useContactModal = ({
  defaultMessage,
  defaultInterest,
  title,
  submitButtonText,
}: UseContactModalProps = {}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return {
    isOpen,
    onOpen,
    onClose,
    modalProps: {
      isOpen,
      onClose,
      defaultMessage,
      defaultInterest,
      title,
      submitButtonText,
    },
  };
};
